/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q3Inputs */

const en_consult_q3 = /** @type {(inputs: Consult_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When do you want to start?`)
};

const id_consult_q3 = /** @type {(inputs: Consult_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapan mau mulai?`)
};

/**
* | output |
* | --- |
* | "When do you want to start?" |
*
* @param {Consult_Q3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q3 = /** @type {((inputs?: Consult_Q3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q3(inputs)
	return en_consult_q3(inputs)
});